import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { generateQueryString } from "src/util/helper";
import IQueryTradesBasicInfo from "../queryStrings/IQueryTradesBasicInfo";
import { saveByteArray } from "src/util/saveByteArray";

enum ReportServiceEnum {
  exportFiledisbursement = "/export-file-to-disbursement?",
  importFileFromAci = "/import-file-from-aci",
  ImportFromFileStatusPayment = "/ted/import/file/status/payment"
}

export default class ReportService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/report");
  }

  public exportTrades = async (queryString: IQueryTradesBasicInfo) => {
    const data = await this.GET(`${ReportServiceEnum.exportFiledisbursement}${generateQueryString(queryString)}`, "blob");
    saveByteArray("FILE_DISBUSERMENT_TO_ACI.csv", data);
    return data;
  };

  public getFileDisbursementToExport = async (): Promise<any> => await this.GET(ReportServiceEnum.exportFiledisbursement);
  public importFromAci = data => this.POST(ReportServiceEnum.importFileFromAci, data);
  public importFromFileStatusPayment = data => this.POST(ReportServiceEnum.ImportFromFileStatusPayment, data);
}



// WEBPACK FOOTER //
// ./src/services/api/ReportService.service.ts